import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import Select from '../../components/ui/Select';
import PartnerDirectory from './components/PartnerDirectory';
import BookingCoordination from './components/BookingCoordination';
import VendorMonitoring from './components/VendorMonitoring';
import PerformanceAnalytics from './components/PerformanceAnalytics';

const TravelPartnersIntegration = () => {
  const [activeTab, setActiveTab] = useState('directory');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');

  const breadcrumbItems = [
    { label: 'Roamsure', path: '/travel-management-dashboard' },
    { label: 'Travel Partners Integration', path: '/travel-partners-integration' }
  ];

  const tabs = [
    { id: 'directory', label: 'Partner Directory', icon: 'Building2' },
    { id: 'booking', label: 'Booking Coordination', icon: 'Calendar' },
    { id: 'monitoring', label: 'Vendor Monitoring', icon: 'Activity' },
    { id: 'analytics', label: 'Performance Analytics', icon: 'BarChart3' }
  ];

  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'airport-pickup', label: 'Airport Pickup' },
    { value: 'security', label: 'Security Services' },
    { value: 'restaurant', label: 'Restaurant Services' },
    { value: 'healthcare', label: 'Healthcare & Clinics' },
    { value: 'accommodation', label: 'Accommodation' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'pending', label: 'Pending Approval' },
    { value: 'suspended', label: 'Suspended' },
    { value: 'maintenance', label: 'Maintenance' }
  ];

  const handleSearch = (e) => {
    setSearchQuery(e?.target?.value);
  };

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'directory':
        return <PartnerDirectory searchQuery={searchQuery} category={selectedCategory} status={selectedStatus} />;
      case 'booking':
        return <BookingCoordination />;
      case 'monitoring':
        return <VendorMonitoring />;
      case 'analytics':
        return <PerformanceAnalytics />;
      default:
        return <PartnerDirectory searchQuery={searchQuery} category={selectedCategory} status={selectedStatus} />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20 px-6 pb-8">
        <Breadcrumb items={breadcrumbItems} />
        
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-foreground mb-2">Travel Partners Integration</h1>
            <p className="text-muted-foreground">Manage vendor relationships and booking coordination</p>
          </div>
          
          <div className="flex items-center space-x-3">
            <Button variant="outline" iconName="Download" size="default">
              Export Report
            </Button>
            <Button variant="default" iconName="Plus" size="default">
              Add Partner
            </Button>
          </div>
        </div>

        {/* Tabs Navigation */}
        <div className="glass-container rounded-xl border border-border/50 mb-6">
          <div className="flex items-center justify-between border-b border-border/50">
            <div className="flex items-center">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center space-x-2 px-6 py-4 border-b-2 transition-all duration-200 ${
                    activeTab === tab?.id
                      ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground'
                  }`}
                >
                  <Icon name={tab?.icon} size={18} />
                  <span className="font-medium">{tab?.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Filters - Show only on directory tab */}
          {activeTab === 'directory' && (
            <div className="p-6 border-b border-border/50">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="md:col-span-1">
                  <Input
                    placeholder="Search partners..."
                    value={searchQuery}
                    onChange={handleSearch}
                    icon="Search"
                  />
                </div>
                <div>
                  <Select
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    options={categoryOptions}
                  />
                </div>
                <div>
                  <Select
                    value={selectedStatus}
                    onChange={handleStatusChange}
                    options={statusOptions}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Tab Content */}
        {renderTabContent()}
      </main>
    </div>
  );
};

export default TravelPartnersIntegration;